import { OAuthConfiguration as Config } from '@celerofinancas/ui-oauth';
import { environment } from './environment';

/**
 * OAuth configuration
 */
export const OAuthConfiguration: Config = {
  ...environment?.authenticationConfig,
  headerWhiteList: ['static.caixa.celero.mobi','.well-known/openid-configuration/', '.csv'],
  refreshWhiteList: ['v2/csrf-token'],
  enablePKCE: true,
  tokenEndpoint: `${environment.apiUrl}/v2/auth/access_token`,
  refreshTokenEndpoint: `${environment.apiUrl}/v2/auth/refresh_token`,
};
